import { Component, inject, OnInit } from '@angular/core';
import { DpFormModule, DpSectionForm } from '@docpath/webcomponents';

import { SelfMaintenance } from './models/self-maintenance';
import { SelfMaintenanceFormService } from './services/self-maintenance-form.service';
import { SelfMaintenanceHttpService } from './services/self-maintenance-http.service';

@Component({
    selector: 'app-configuration-self-maintenance',
    templateUrl: './self-maintenance.component.html',
    standalone: true,
    imports: [DpFormModule]
})
export class SelfMaintenanceComponent implements OnInit {

    sectionForm: DpSectionForm;

    private readonly selfMaintenanceHttpService = inject(SelfMaintenanceHttpService);
    private readonly selfMaintenanceFormService = inject(SelfMaintenanceFormService);

    constructor() {
        this.sectionForm = this.selfMaintenanceFormService.getSectionForm();
    }

    ngOnInit(): void {

        this.selfMaintenanceHttpService.getSelfMaintenanceConfig().subscribe(config => {
            this.sectionForm.setValue({ config });
        });

    }

    submitForm() {

        const { config } = this.sectionForm.getValue();
        const modifiedMaintenance = new SelfMaintenance(
            config.enable,
            config.startMaintenance,
            config.enableRemoveLogs,
            config.daysKeepLogs,
            config.enableRemoveData,
            config.daysKeepData,
            config.enableRemoveJobs,
            config.daysKeepJobs);

        this.selfMaintenanceHttpService.updateSelfMaintenanceConfig(modifiedMaintenance).subscribe(() => {
            this.sectionForm.setValue({ config: modifiedMaintenance });
        });

    }

}